var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-card',{staticClass:"card-chart",attrs:{"title":_vm.$t('therms.distribution')}},[_c('vue-apex-charts',{attrs:{"type":"donut","height":"350","options":_vm.chart.chartOptions,"series":_vm.chart.series}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }